export default {
  documento: {
    value: '',
    maxlength: '100',
    required: true,
    state: null
  },
  nome: {
    value: '',
    maxlength: '100',
    required: true,
    state: null
  },
  email: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  celular: {
    value: '',
    maxlength: '15',
    required: false,
    state: null
  },
  criarCard: {
    value: true,
    defaultBoolean: true,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/campaign/components/list/modal/emailtestmodal/sendtest-form.js